/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display metadata popup window
*/
import React, { Component } from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import PropTypes from "prop-types";

export default class FileUploadDisplayComponent extends Component {
    static get propTypes() {
        return {
            file: PropTypes.array,
            percentage: PropTypes.number.isRequired,
            failedMsg: PropTypes.string.isRequired,
            showBatchStatus: PropTypes.string.isRequired,
            showReplacePopup: PropTypes.string
        };
    }

    render() {
        return (
            <div className="pe-col-12 display-table" >
                <div className="pe-col-5">
                    <b> {TEXT_TYPES.FILE_NAME} </b>
                </div>
                <div className="pe-col-7">
                    <b> {TEXT_TYPES.UPLOAD_PROGRESS} </b>
                </div>
                <div className="pe-col-12">
                    <br />
                </div>
                <div className="filecontent pe-col-12">
                    <div className="pe-col-5">
                        {this.props.file}
                    </div>
                    {this.props.percentage != 0
                        && <div className="pe-col-4">
                            <ProgressBar min={0} max={100} value={this.props.percentage}
                                type="animated" alignLabel="left" id="cc-upload-progress-bar" />
                        </div>
                    }
                    {this.props.showBatchStatus != "" && this.props.percentage == 0
                        && <div className="pe-col-6">
                            {this.props.showBatchStatus}
                            <div className="errorMsg">
                                <b> {this.props.failedMsg} </b>
                            </div>
                            <div className="replaceMsg">
                                <a onClick={this.props.showReplacePopup}> {this.props.replaceMsg} </a>
                            </div>
                        </div>
                    }
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgets/FileUploadDisplay/FileUploadDisplayComponent.js